import { useTranslation } from "react-i18next";
import { SsoButton } from "@/components/SsoButton";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function Login() {
  const { t } = useTranslation();
  return (
    <section className="mx-auto max-w-md py-8">
      <Card>
        <CardHeader className="text-center">
          <CardTitle asChild className="text-3xl">
            <h1>{t("auth:signIn")}</h1>
          </CardTitle>
          <CardDescription>{t("auth:ssoExplainer")}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3">
          <SsoButton className="w-full" />
          <p className="text-center text-xs text-muted-foreground">{t("auth:noPasswordHere")}</p>
        </CardContent>
      </Card>
    </section>
  );
}
